import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-driver" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "new-modal" }
const _hoisted_6 = { class: "description__footer" }

import { InfoCircle, SearchMd } from "utruckin-icons";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import { useTeamStore } from "@/features/teams/team.store";
import { computed, onMounted, ref, watch } from "vue";
import { ITeam } from "@/features/teams/team.types";
import { DateTime } from "luxon";
import { ICompany } from "@/features/company/company.types";
import { useDriverStore } from "@/features/drivers/drivers.store";
import { useNotification } from "@/utils/notification";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import { useAppStore } from "@/store/app.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'DriversView',
  setup(__props) {

const teamStore = useTeamStore();
const driverStore = useDriverStore();
const appStore = useAppStore();

const { pushNotification } = useNotification();

const teams = ref<ITeam[]>([]);
const team = ref<string | null>(null);
const driverLoading = ref(false);
const search = ref<string>("");
const drivers = ref<ICompany[]>([]);

const isOpenModal = ref<boolean>(false);
const note = ref<string>("");
const modalItem = ref<ICompany | null>(null);

let searchTimer: ReturnType<typeof setTimeout> | null = null;

const openModal = (item: ICompany) => {
  modalItem.value = item;
  isOpenModal.value = true;
  note.value = item.note;
};

const closeModal = () => {
  modalItem.value = null;
  isOpenModal.value = false;
  note.value = "";
};

const saveModal = async () => {
  if (!modalItem.value) return;

  await driverStore.addDriverNote(
    driverLoading,
    modalItem.value.id,
    { note: note.value },
    async (data: any) => {
      if (data) {
        pushNotification("Successfully unarchived", "success");
        closeModal();
        await getList();
      }
    }
  );
};

const teamItems = computed(() =>
  teams.value.map((t) => ({ value: t.id, name: t.name }))
);

const getTeamName = (teamId: string | null): string => {
  if (!teamId) return "—";
  const found = teams.value.find((t) => t.id === teamId);
  return found?.name || "—";
};

function datepickerToUtcDateOnly(d: Date | null | undefined) {
  return DateTime.fromISO(d, {
    zone: "utc",
  })
    .setZone("America/New_York")
    .toFormat("yyyy-MM-dd");
}

const getList = async () => {
  const teamLoading = ref(false);
  [teams.value, drivers.value] = await Promise.all([
    teamStore.getTeams(teamLoading),
    driverStore.getDrivers(driverLoading),
  ]);
};

onMounted(() => {
  getList();
});

watch(search, (val) => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(async () => {
    driverStore.commonFilter.search = val;
    await getList();
  }, 400);
});

watch(team, async (val) => {
  driverStore.commonFilter.team_id = val as string;
  await getList();
});

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CommonSearch, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        icon: _unref(SearchMd),
        placeholder: "Search",
        clearable: ""
      }, null, 8, ["modelValue", "icon"]),
      _createVNode(CommonDropdown, {
        modelValue: team.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((team).value = $event)),
        items: teamItems.value,
        label: "Team",
        clearable: ""
      }, null, 8, ["modelValue", "items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CommonTable, {
        headers: _unref(driverStore).driverHeaders,
        loading: driverLoading.value,
        items: drivers.value.items
      }, {
        id: _withCtx(({ index }) => [
          _createElementVNode("span", null, _toDisplayString(index + 1), 1)
        ]),
        eld_last_activity_at: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(datepickerToUtcDateOnly(item.eld_last_activity_at)), 1)
        ]),
        team: _withCtx(({ item }) => [
          _createElementVNode("span", null, _toDisplayString(getTeamName(item.team_id)), 1)
        ]),
        actions: _withCtx(({ item }) => [
          _createElementVNode("div", {
            class: "action",
            onClick: ($event: any) => (openModal(item))
          }, [
            _createVNode(_unref(InfoCircle), { size: 18 })
          ], 8, _hoisted_4)
        ]),
        _: 1
      }, 8, ["headers", "loading", "items"])
    ]),
    _createVNode(CommonModal, {
      modelValue: isOpenModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isOpenModal).value = $event)),
      title: "Driver note"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeModal
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveModal
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(CommonInput, {
            modelValue: note.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((note).value = $event)),
            label: "Note",
            multiline: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})